import { Spinner } from 'design-system';

type PostGenerationBodyProps = {
  isError: boolean;
  loading: boolean;
};

const PostGenerationBody = ({ isError, loading }: PostGenerationBodyProps) => {
  if (isError) {
    return (
      <>
        <p>Error generating ApiKey</p>
        <p>Please contact the General Index support team.</p>
      </>
    );
  }

  if (loading) {
    return <Spinner className='size-10' />;
  }

  return <p>Your token has been created. You can now retrieve the API token.</p>;
};

export default PostGenerationBody;
